<template>
  <div class="description">
      <section>
        <div class="header">一、交易欺诈的定义</div>
        <div class="content">
          一方以正常交易为目的，交易相对方在交易过程中通过诱导其违背正常交易流程等方式导致钱、货一方，同时该交易相对方怠于或拒绝履行赔付或返还等义务的，经平台判责确认为交易欺诈行为。
        </div>
      </section>

      <section>
        <div class="header">二、申请赔付的条件</div>
        <div class="article">
          <div class="title" v-for="(item, idx) in KnowledgeList" :key="idx">
            <div>{{ idx + 1 }}、</div>
            <div class="title-content">{{ item }}；</div>
          </div>
        </div>
      </section>

      <section>
        <div class="header">三、不符合赔付保障服务的情形</div>
        <div class="article">
          <div class="title" v-for="(item, idx) in caseList" :key="idx">
            <div>{{ idx + 1 }}、</div>
            <div class="title-content">{{ item }}；</div>
          </div>
          <div class="title">满足以上任一情形即无法享受追款或赔付保障服务。</div>
        </div>
      </section>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'

const KnowledgeList = [
  '须为实物商品交易',
  '交易已造成了钱、货均在一方手里，而该方怠于或拒绝履行赔付或返还等义务，经平台判定欺诈事实成立',
  '交易全程（包括但不限于下单、支付、即时沟通等）均在转转平台内，未脱离转转平台',
  '订单状态为交易成功，且相关损失未通过平台、交易相对方或其他第三方赔偿得以弥补',
  '须上传收货开箱/打包发货视频',
  '申请人的交易行为未违反《转转用户服务协议》《商品发布条例》《用户行为规范》《用户处罚条例》等相关协议、规则或法律法规',
  '单个用户的平台协助追款上限为订单金额，平台赔付上限为2000元；每个自然人用户在1年内只能申请1笔交易订单追款/赔付。如果单笔交易金额大于3000元（含），申请人需提供公安部门出具的报案受理回执证明',
  '在放心转保障有效期内发生欺诈且订单完成后30天内可申请赔付',
  '交易及案件相关证明材料齐全，材料中个人信息应与平台内实人信息保持一致。如出现冒领、伪造，平台有权追究法律责任'
]
const caseList = [
  '不符合上述赔付申请条件的',
  '该交易行为本身违反法律法规、平台协议、规则的规定（如刷单套现、禁售商品等）',
  '卖家在发布商品时对商品类别错置（如手机商品发布在服装鞋帽等非手机品类中或其他品类商品发布在手机品类中等）',
  '经平台判断，交易行为存在异常情形或非基于正常消费目的（如交易双方串通骗取牟利、职业索赔牟利等）',
  '经平台判断，历史行为中存在严重违规的用户（如涉嫌欺诈、售卖假货、发布禁售商品等）',
  '因虚假宣传、质量瑕疵、不符合承诺、价格诱导、交易违规等行为引发的交易纠纷，适用平台其他服务或规则（如有）处理，暂不属于放心转欺诈赔付保障的范围内',
  '由于个人故意或误操作、或未操作导致的损失（包括但不限于：未收到货物时即主动点击“确认收货”，未关注交易进程导致交易完成、系统自动付款给卖家，退货退款情形下未收到货物时点击“确认退款”等）',
  '其他平台认为不应当赔付的情形'
]
export default {
  name: 'LawVersion',
  data() {
    return {
      expend: false,
      KnowledgeList,
      caseList
    }
  },
  components: {},
  methods: {
    expendHistory() {
      this.expend = !this.expend
    }
  },
  mounted() {
    native.setTitle({
      title: '放心转保障规则'
    })
  },
  destroyed() {},
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
